<div class="container-fluid row_banner pb-5">
  <app-header></app-header>
  <div class="container">
    <div
      class="row text-center justify-content-center"
      style="align-content: center"
    >
      <div class="col-lg-9 col-md-9 mb-4" id="footergrammartext">
        <h1 class="w-100 fnt-w600-40" style="margin-top: 40px">
          Article Rewriter
        </h1>
        <span class="w-100 d-inline-block main_text mt-40"
          >Replace the wording and sentences of your articles with their best
          possible alternatives.
        </span>
      </div>
    </div>
    <div class="custom-card">
      <p
        class="text-left success-msg"
        *ngIf="got_recpatcha"
        [ngStyle]="{
          color: color,
          'background-color': '#f8d7da',
          padding: '2px'
        }"
      >
        <i class="fa fa-times-circle matr ml-1" aria-hidden="true"></i>
        {{ recaptcha_message }}
      </p>
      <div class="row">
        <div class="col-lg-1 col-md-2 col-12 icon-bar mt45">
          <div class="icon-bar">
            <div
              class="icon-bar-img"
              id="uploadFileS"
              value="Browse"
              onclick="document.getElementById('upload').click();"
            >
              <app-icons-free-tools [name]="'pcIcon'" />
              <input
                id="upload"
                data-name="upload-element"
                #fileInput
                accept=".txt,.doc,.docx,.pdf,.odt,.rtf,.tex"
                type="file"
                (change)="uploadFileSaveRedirect($event)"
              />
            </div>
            <div class="icon-bar-img" (click)="openDropboxChooser()">
              <app-icons-free-tools [name]="'dropboxIcon'" />
            </div>
            <div class="icon-bar-img" (click)="gDriveUpload()">
              <app-icons-free-tools [name]="'googleIcon'" />
            </div>
          </div>
        </div>
        <div class="col-lg-11 col-md-10 col-12 top-bar">
          <div class="row">
            <div class="col-lg-6 col-md-12 col-sm-12" style="overflow: hidden">
              <div
                class="upload-section"
                id="editor"
                #editor
                ngDefaultControl
                contenteditable="true"
                (click)="onclickeditor($event)"
                [(ngModel)]="text"
                contenteditable="true"
                (keyup)="getContent($event, text)"
                spellcheck="false"
                data-gramm="false"
                style="overflow-y: auto; overflow-x: hidden"
              ></div>
              <div *ngIf="showParagraph" class="editSectionDiv">
                <div *ngFor="let content of contentArray">
                  <app-icons-free-tools [name]="'checktextIcon'" />
                  <h3 class="editor-heading">{{ content.header }}</h3>
                  <p class="paragraph">{{ content.paragraph }}</p>
                  <div class="upload-buttons">
                    <button
                      [ngClass]="{
                        paste: button.text === 'Sample Text',
                        click: button.text === 'Paste Text',
                        'default-class': true
                      }"
                      *ngFor="let button of content.buttons"
                      class="textButtons"
                      (click)="executeAction(button.action)"
                    >
                      <app-icons-free-tools [name]="button.icon" />{{
                        button.text
                      }}
                    </button>
                  </div>
                </div>
              </div>
              <span *ngIf="char_count !== 0">
                <app-icons-free-tools
                  [name]="'deleteIcon'"
                  (click)="deleteText()"
                  class="icon-del"
                />
              </span>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12">
              <div
                class="result-section"
                style="overflow-x: hidden"
                id="editor2"
                contenteditable="false"
                spellcheck="false"
                data-gramm="false"
                (click)="onTextClick($event)"
              >
                <img
                  src="../../assets/images/article-rewriter/result-section.png"
                  class="result-section-img"
                  style="
                    position: relative;
                    top: 40%;
                    left: 49%;
                    text-align: center;
                    transform: translate(-50%, -50%);
                  "
                />
              </div>
            </div>
            <div
              class="popup"
              id="popupArt"
              *ngIf="popupVisible"
              [ngStyle]="{ top: popupPosition.top, left: popupPosition.left }"
            >
              <div>
                <h6 style="text-align: left; font-size: 16px; font-weight: 600">
                  Original word:
                </h6>
                <div
                  style="
                    margin: 5px 0px;
                    background-color: #08ba9c;
                    display: inline-block;
                    height: 30px;
                    padding: 1px 10px 30px 10px;
                    cursor: pointer;
                    border-radius: 5px;
                    color: #ffffff;
                  "
                >
                  {{ firstSynonym }}
                </div>
                <h6 style="text-align: left; font-size: 16px; font-weight: 600">
                  Suggestion(s):
                </h6>
                <div
                  (click)="selectSynonym(synonym)"
                  style="
                    border: 1px solid #08ba9c;
                    border-radius: 5px;
                    margin-right: 5px;
                    background-color: #ffffff;
                    color: #08ba9c;
                    margin-bottom: 10px;
                    padding: 5px;
                    display: inline-block;
                    cursor: pointer;
                    text-align: left;
                  "
                  *ngFor="let synonym of popupSynonyms"
                >
                  {{ synonym }}
                </div>
                <p style="font-size: 16px; font-weight: 600">Enter New:</p>
                <div style="margin-top: 10px; display: flex">
                  <input
                    class="form-control"
                    type="text"
                    id="userInput"
                    style="
                      height: 40px;
                      border-radius: 5px;
                      outline: none;
                      box-shadow: none;
                      margin-right: 5px;
                    "
                    [(ngModel)]="inputText"
                    autocomplete="off"
                    placeholder="Enter New"
                  />
                  <button
                    (click)="useInputText()"
                    class="popuoUseBtn"
                    [disabled]="!inputText || inputText.trim() === ''"
              
                  >
                    Use
                  </button>
                </div>
              </div>
              <div (click)="closepopUpArt()">
                <img
                  alt="popup_img"
                  src="../../assets/images/editorimages/articlecross.svg"
                  style="margin-top: -23px; height: 25px"
                />
              </div>
            </div>
          </div>
          <div class="progress-loader-div">
            <div class="progress-loader" *ngIf="loaderAlert"></div>
          </div>
          <div class="edit-buttons">
            <div class="word-count">
             
                <p
                  class="word-limit"
                  style="font-size: 15px; font-weight: 500; text-align: left"
                >
                  Words:{{ char_count === 0 ? 0 : word_count }}
                </p>
                <p style="font-size: 15px; font-weight: 500; text-align: left">
                  Total Characters: {{ char_count }}
                </p>
          
             
            </div>
           
            <div class=" right-buttons">
              <div style="    display: flex;    ;
              ">
              <button
                id="adv-tech"
                class="download-img tooltipss butn"
                aria-label="Try Again"
                (click)="handleButtonClick()"
                *ngIf="gotresponse"
              >
                <img id="retry" />
                <span class="tooltiptext">Retry</span>
              </button>
              <button
                id="adv-tech"
                class="download-img tooltipss butn"
                (click)="copyText()"
                *ngIf="gotresponse"
              >
                <img
                  src="../../assets/images/About us-assets/copy-frame.svg"
                  alt=""
                />
                <span class="tooltiptext">Copy</span>
                <span
                  class="tooltiptext"
                  id="copried_txt"
                  *ngIf="!showParagraph && copiedtext"
                  >Copied</span
                >
              </button>

              <button
                class=" unquieBtn"
                (click)="downloadText()"
                *ngIf="gotresponse"
              >
                <img
                  src="../assets/images/plagiarism checker1/downPlag.svg"
                  alt="download-img"
                  class="unquieBtnImg"
                />
               <span> Download</span>
              </button>
            </div>
              <div *ngIf="captchaVisible" class="captcha-modal-overlay">
                <div class="captcha-modal">
                  <div
                    id="recaptcha-container"
                    class="recaptcha-container"
                    data-size="compact"
                    data-theme="light"
                  ></div>
                </div>
              </div>
                <div>
              <button
                class="btn btn-dark btn-summarize"
                (click)="handleButtonClick()"
              >
    
                Rewrite Article
              </button>
            </div>
            </div>
          </div>
         
          <div
            *ngIf="error"
            class="backdrop"
            style="
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-color: rgba(0, 0, 0, 0.5);
              z-index: 1000;
            "
          ></div>

          <div
            *ngIf="error"
            class="content-div"
            style="
              position: fixed;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 468px;
              height: 360px;
              background-color: white;
              z-index: 1010;
              border-radius: 4px;
              border: 1px solid white;
            "
          >
            <div class="text-center tab_screen" style="margin-top: 9%">
           
              <app-icons-free-tools name="errorIcon" />

              <div style=" margin-left: 16px">
                <p
                  class="error mt-4 content-div-p"
                  style="
                    font-size: 28px;
                    font-weight: 500;
                    line-height: 33.89px;
                  "
                >
                  {{ errorAlerts }}
                </p>
              </div>

              <button class=" butn-alert" (click)="closeErrorDiv()">
                Ok
              </button>
            </div>
          </div>

          <div
            *ngIf="success"
            class="backdrop"
            style="
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-color: rgba(0, 0, 0, 0.5);
              z-index: 1000;
            "
          ></div>

          <div
            *ngIf="success"
            class="content-div content-div-p"
            style="
              position: fixed;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 468px;
              height: 360px;
              background-color: white;
              z-index: 1010;
              border-radius: 4px;
              border: 1px solid white;
            "
          >
            <div class="text-center tab_screen" style="margin-top: 9%">
             
              <app-icons-free-tools name="successIcon" />

              <p
                *ngIf="success"
                class="error mt-4"
                style="font-size: 24px; font-weight: 500; line-height: 33.89px"
              >
                {{ successAlert }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div
  class="container justify-content-center"
  id="how-to-use-bg "
  style="margin-top: 100px"
>
  <div class="row mt-5" style="box-sizing: border-box">
    <div class="col-md-12">
      <h2
        style="
          text-align: center;
          font-size: 30px;
          font-weight: 700;
          line-height: 37.8px;
          text-align: center;
        "
      >
        How to Use This Article Rewriter for Perfect Results? - Steps
      </h2>
    </div>
    <div
      class="col-md-12"
      style="
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        line-height: 30px;
      "
    >
      <p>
        Using the rewriter tool by GrammarIn is as easy as pie. You don’t need
        any training or expertise. All you need is the <br />
        right approach to use this web utility, which is described in the
        following steps:
      </p>
    </div>
  </div>
</div>
<div class="container">
  <div class="row justify-content-center">
    <div class="col-md-4">
      <div class="summ-envision-content" style="display: flex">
        <img
          src="../../assets/images/article-rewriter/upload.svg"
          alt="Vector1"
          class="summ-content-img"
        />
        <p class="summ-content-p">
          Upload a document file or enter the text in the specified section..
        </p>
      </div>
    </div>
    <div class="col-md-4">
      <div class="summ-envision-content">
        <img
          src="../../assets/images/article-rewriter/select mode.svg"
          alt="Vector2"
          class="summ-content-img"
        />
        <p class="summ-content-p">Select a mode from the provided options</p>
      </div>
    </div>
    <div class="col-md-4">
      <div class="summ-envision-content">
        <img
          src="../../assets/images/article-rewriter/now click.svg"
          alt="Vector3"
          class="summ-content-img"
        />
        <p class="summ-content-p">
          Now, click on the “Rewrite Article” button to initiate the procedure.
        </p>
      </div>
    </div>
  </div>
  <div class="row justify-content-center mt-3">
    <div class="col-md-4">
      <div class="summ-envision-content">
        <img
          src="../../assets/images/article-rewriter/the tool.svg"
          alt="Vector4"
          class="summ-content-img"
        />
        <p class="summ-content-p">
          The tool will analyze your text and extract its main points.
        </p>
      </div>
    </div>
    <div class="col-md-4">
      <div class="summ-envision-content">
        <img
          src="../../assets/images/article-rewriter/copy.svg"
          alt="Vector5"
          class="summ-content-img"
        />
        <p class="summ-content-p">
          Copy the summarized text and paste it into your writing project.
        </p>
      </div>
    </div>
  </div>
</div>

<div class="container mt-5">
  <app-premium />
</div>

<div
  class="container justify-content-center"
  id="how-to-use-bg "
  style="margin-top: 100px"
>
  <div class="row mt-5" style="box-sizing: border-box" id="para-key-main">
    <div class="col-md-12">
      <h2
        style="
          text-align: center;
          font-size: 30px;
          font-weight: 700;
          line-height: 37.8px;
          text-align: center;
        "
      >
        AI-Generated Content Detection Model
      </h2>
    </div>
    <div
      class="col-md-12"
      style="
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        line-height: 30px;
      "
    >
      <p>
        Our AI text detector performs the AI detection process in multiple
        phases. A brief glimpse of how this AI tool works is shared below.
      </p>
    </div>
    <div class="tabs_wrapper">
      <div class="col-lg-6 d-md-none d-block s">
        <div class=" ">
          <select
            class="form-select mb-3"
            [(ngModel)]="selectedTab"
            (change)="selectTab(selectedTab)"
          >
            <option value="tab1">Simple and clean User Interface</option>
            <option value="tab2">Unique and Flawless Content Creation</option>
            <option value="tab3">Synonyms Suggestion</option>
            <option value="tab4">Deep Spinning</option>
            <option value="tab5">Availability of Multiple Modes</option>
            <option value="tab6">Safe and Secure</option>
            <option value="tab7">Extensive File Support</option>
            <option value="tab8">
              Multilingual Accessibility and Operability
            </option>
            <option value="tab9">No Word Count Limit</option>
          </select>
        </div>
      </div>
      <div class="col-lg-6 d-md-block d-none">
        <div class="btns-divs">
          <button
            class="mb-3 mybtn p-2"
            [ngClass]="{ active: selectedTab === 'tab1' }"
            (click)="selectTab('tab1')"
            id="adv-tech"
          >
            <img
              id="simple-clean"
              class="section-3-plag-tabs-img me-3 ms-2"
              alt="plag-img"
            />
            <h3 class="section-3-plag-tabs-p" style="margin-top: 5px">
              Simple and clean User Interface
            </h3>
          </button>
          <button
            class="mb-3 mybtn p-2"
            [ngClass]="{ active: selectedTab === 'tab2' }"
            (click)="selectTab('tab2')"
            id="adv-tech"
          >
            <img
              id="unique-content"
              class="section-3-plag-tabs-img me-3 ms-2"
              alt="plag-img"
            />
            <h3 class="section-3-plag-tabs-p">
              Unique and Flawless Content Creation
            </h3>
          </button>
          <button
            class="mb-3 mybtn p-2"
            [ngClass]="{ active: selectedTab === 'tab3' }"
            (click)="selectTab('tab3')"
            id="adv-tech"
          >
            <img
              id="synonyms-suggestion"
              class="section-3-plag-tabs-img me-3 ms-2"
              alt="plag-img"
            />
            <h3 class="section-3-plag-tabs-p" style="margin-top: 0px">
              Synonyms Suggestion
            </h3>
          </button>
          <button
            class="mb-3 mybtn p-2"
            [ngClass]="{ active: selectedTab === 'tab4' }"
            (click)="selectTab('tab4')"
            id="adv-tech"
          >
            <img
              id="deep-spining"
              class="section-3-plag-tabs-img me-3 ms-2"
              alt="plag-img"
            />
            <h3 class="section-3-plag-tabs-p">Deep Spinning</h3>
          </button>
          <button
            class="mb-3 mybtn p-2"
            [ngClass]="{ active: selectedTab === 'tab5' }"
            (click)="selectTab('tab5')"
            id="adv-tech"
          >
            <img
              id="Multiple-mode"
              class="section-3-plag-tabs-img me-3 ms-2"
              alt="plag-img"
            />
            <h3 class="section-3-plag-tabs-p">Availability of Multiple Mode</h3>
          </button>
          <button
            class="mb-3 mybtn p-2"
            [ngClass]="{ active: selectedTab === 'tab6' }"
            (click)="selectTab('tab6')"
            id="adv-tech"
          >
            <img
              id="safe-secure"
              class="section-3-plag-tabs-img me-3 ms-2"
              alt="plag-img"
            />
            <h3 class="section-3-plag-tabs-p">Safe and Secure</h3>
          </button>
          <button
            class="mb-3 mybtn p-2"
            [ngClass]="{ active: selectedTab === 'tab7' }"
            (click)="selectTab('tab7')"
            id="adv-tech"
          >
            <img
              id="extensive-file"
              class="section-3-plag-tabs-img me-3 ms-2"
              alt="plag-img"
            />
            <h3 class="section-3-plag-tabs-p">Extensive File Support</h3>
          </button>
          <button
            class="mb-3 mybtn p-2"
            [ngClass]="{ active: selectedTab === 'tab8' }"
            (click)="selectTab('tab8')"
            id="adv-tech"
          >
            <img
              id="access-operability"
              class="section-3-plag-tabs-img me-3 ms-2"
              alt="plag-img"
            />
            <h3 class="section-3-plag-tabs-p">
              Multilingual Accessibility and Operability
            </h3>
          </button>
          <button
            class="mb-3 mybtn p-2"
            [ngClass]="{ active: selectedTab === 'tab9' }"
            (click)="selectTab('tab9')"
            id="adv-tech"
          >
            <img
              id="count-limit"
              class="section-3-plag-tabs-img me-3 ms-2"
              alt="plag-img"
            />
            <h3 class="section-3-plag-tabs-p">No Word Count Limit</h3>
          </button>
        </div>
      </div>
      <div class="col-lg-6">
        <div
          class="tab_container"
          style="background-color: #f7f7fa; border-radius: 8px"
        >
          <div *ngIf="selectedTab === 'tab1'" class="tab_content">
            <p id="contentss">
              This rewrite tool eliminates the complexity of the entire
              rewording process. It presents the users with a stright forword
              and uncluttered Ul. All the options in its user interface are
              self-explanatory and very well-organized.
            </p>
          </div>
          <div *ngIf="selectedTab === 'tab2'" class="tab_content">
            <p id="contentss">
              Our article rewriter highlights the modified words in the output
              section. Users can hover or tap over the highlighted terms to
              explore our tool’s recommendations for synonyms. Use the provided
              synonyms suggestions to bring variance to your article’s
              vocabulary.
            </p>
          </div>
          <div *ngIf="selectedTab === 'tab3'" class="tab_content">
            <p id="contentss">
              Our article rewriter highlights the modified words in the output
              section. Users can hover or tap over the highlighted terms to
              explore our tool’s recommendations for synonyms. Use the provided
              synonyms suggestions to bring variance to your article’s
              vocabulary.
            </p>
          </div>
          <div *ngIf="selectedTab === 'tab4'" class="tab_content">
            <p id="contentss">
              This AI rewriting tool is more than a basic article spinner.
              Instead of entirely relying on the synonym replacement, our web
              utility deeply spins the input using the combination of sentence
              restructuring and word reordering strategies. Therefore, it has
              been programmed to take a unique approach while rewriting the
              provided article.
            </p>
          </div>
          <div *ngIf="selectedTab === 'tab5'" class="tab_content">
            <p id="contentss">
              This free article rewriter is more than a simple rewording
              utility. It provides the users with multiple modes. Users can use
              them to modify the writing tone of their articles without altering
              their crux.
            </p>
          </div>
          <div *ngIf="selectedTab === 'tab6'" class="tab_content">
            <p id="contentss">
              At grammarin.com, we understand how challenging it can be to write
              an original article. Therefore, the safety and security of your
              data is our priority. Since our rewriter tool doesn’t use the
              assistance of any third-party services, it doesn’t share your
              data. In fact, our tool completely erases the traces of uploaded
              data from its servers upon being reloaded.
            </p>
          </div>
          <div *ngIf="selectedTab === 'tab7'" class="tab_content">
            <p id="contentss">
              This AI rewriting tool is a universal web utility. From PDF and
              Word to raw text files, users can upload all types of documents to
              this tool. It will revamp their wording while keeping the original
              context intact.
            </p>
          </div>
          <div *ngIf="selectedTab === 'tab8'" class="tab_content">
            <p id="contentss">
              The article rewriter by grammarin.com has been developed to
              operate in multiple languages. With this web utility, you can
              generate high-quality, revamped versions of your articles written
              in any popular language.
            </p>
          </div>
          <div *ngIf="selectedTab === 'tab9'" class="tab_content">
            <p id="contentss">
              Our tool understands that sometimes, articles can be lengthy.
              Therefore, it has been programmed to handle lengthy chunks of text
              in one go. You won’t have to break a long article into multiple
              sections in order to rewrite it with our web utility.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="container"
    style="margin-top: 50px; box-sizing: border-box; text-align: left"
    id="para-key-phone"
  >
    <h2
      style="
        text-align: center;
        font-size: 30px;
        font-weight: 700;
        line-height: 37.8px;
        text-align: center;
      "
    >
      AI-Generated Content Detection Model
    </h2>
    <p
      style="
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        line-height: 30px;
      "
    >
      Our AI text detector performs the AI detection process in multiple phases.
      A brief glimpse of how this AI tool works is shared below.
    </p>
    <div class="v-pills-tab-list row" id="v-pills-tab-list">
      <div class="" id="row_faqs">
        <div
          class="nav flex-column nav-pills"
          id="v-pills-tab"
          role="tablist"
          aria-orientation="vertical"
        >
          <a
            class="nav-link nav-pills"
            style="margin: 8px 0; padding: 10px 14px; background: #fff"
            class="card active"
            id="v-pills-first-tab"
            aria-controls="q122"
            aria-expanded="false"
            class="mb-0 collapsed"
            data-toggle="collapse"
            href="#q122"
          >
            <h5>
              <span
                class="btn active"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne_One"
                aria-expanded="true"
                aria-controls="collapseOne_One"
                class="card-header headingsize"
              >
                Simple and clean User Interface</span
              >
              <i class="fas fa-chevron-down float-right down"></i>
            </h5>
            <div
              aria-labelledby="q122"
              class="collapse"
              id="q122"
              role="tabpanel"
              data-parent="#v-pills-tab-list"
            >
              <div class="card-body">
                This rewrite tool eliminates the complexity of the entire
                rewording process. It presents the users with a stright forword
                and uncluttered Ul. All the options in its user interface are
                self-explanatory and very well-organized.
              </div>
            </div>
          </a>
          <hr style="margin-top: 0px; margin-bottom: 0px" />
          <a
            class="nav-link nav-pills"
            style="margin: 8px 0; padding: 10px 14px; background: #fff"
            class="card active"
            id="v-pills-2nd-tab"
            aria-controls="q12"
            aria-expanded="false"
            class="mb-0 collapsed"
            data-toggle="collapse"
            href="#q64"
          >
            <h5>
              <span
                class="btn active"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne_One"
                aria-expanded="true"
                aria-controls="collapseOne_One"
                class="card-header headingsize"
              >
                Unique and Flawless Content Creation</span
              >
              <i class="fas fa-chevron-down float-right down"></i>
            </h5>
            <div
              aria-labelledby="q122"
              class="collapse"
              id="q64"
              role="tabpanel"
              data-parent="#v-pills-tab-list"
            >
              <div class="card-body">
                Our article rewriter highlights the modified words in the output
                section. Users can hover or tap over the highlighted terms to
                explore our tool’s recommendations for synonyms. Use the
                provided synonyms suggestions to bring variance to your
                article’s vocabulary.
              </div>
            </div>
          </a>
          <hr style="margin-top: 0px; margin-bottom: 0px" />
          <a
            class="nav-link nav-pills"
            style="margin: 8px 0; padding: 10px 14px; background: #fff"
            class="card active"
            id="v-pills-2nd-tab"
            aria-controls="q12"
            aria-expanded="false"
            class="mb-0 collapsed"
            data-toggle="collapse"
            href="#q74"
          >
            <h5>
              <span
                class="btn active"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne_One"
                aria-expanded="true"
                aria-controls="collapseOne_One"
                class="card-header headingsize"
              >
                Synonyms Suggestion</span
              >
              <i class="fas fa-chevron-down float-right down"></i>
            </h5>
            <div
              aria-labelledby="q12"
              class="collapse"
              id="q74"
              role="tabpanel"
              data-parent="#v-pills-tab-list"
            >
              <div class="card-body">
                Our article rewriter highlights the modified words in the output
                section. Users can hover or tap over the highlighted terms to
                explore our tool’s recommendations for synonyms. Use the
                provided synonyms suggestions to bring variance to your
                article’s vocabulary.
              </div>
            </div>
          </a>
          <hr style="margin-top: 0px; margin-bottom: 0px" />
          <a
            class="nav-link nav-pills"
            style="margin: 8px 0; padding: 10px 14px; background: #fff"
            class="card active"
            id="v-pills-2nd-tab"
            aria-controls="q12"
            aria-expanded="false"
            class="mb-0 collapsed"
            data-toggle="collapse"
            href="#q81"
          >
            <h5>
              <span
                class="btn active"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne_One"
                aria-expanded="true"
                aria-controls="collapseOne_One"
                class="card-header headingsize"
                >Deep Spining</span
              >
              <i class="fas fa-chevron-down float-right"></i>
            </h5>
            <div
              aria-labelledby="q12"
              class="collapse"
              id="q81"
              role="tabpanel"
              data-parent="#v-pills-tab-list"
            >
              <div class="card-body">
                This AI rewriting tool is more than a basic article spinner.
                Instead of entirely relying on the synonym replacement, our web
                utility deeply spins the input using the combination of sentence
                restructuring and word reordering strategies. Therefore, it has
                been programmed to take a unique approach while rewriting the
                provided article.
              </div>
            </div>
          </a>
          <hr style="margin-top: 0px; margin-bottom: 0px" />
          <a
            class="nav-link nav-pills"
            style="margin: 8px 0; padding: 10px 14px; background: #fff"
            class="card active"
            id="v-pills-2nd-tab"
            aria-controls="q12"
            aria-expanded="false"
            class="mb-0 collapsed"
            data-toggle="collapse"
            href="#q82"
          >
            <h5>
              <span
                class="btn active"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne_One"
                aria-expanded="true"
                aria-controls="collapseOne_One"
                class="card-header headingsize"
                >Availability of Multiple Mode</span
              >
              <i class="fas fa-chevron-down float-right"></i>
            </h5>
            <div
              aria-labelledby="q12"
              class="collapse"
              id="q82"
              role="tabpanel"
              data-parent="#v-pills-tab-list"
            >
              <div class="card-body">
                This free article rewriter is more than a simple rewording
                utility. It provides the users with multiple modes. Users can
                use them to modify the writing tone of their articles without
                altering their crux.
              </div>
            </div>
          </a>
          <hr style="margin-top: 0px; margin-bottom: 0px" />
          <a
            class="nav-link nav-pills"
            style="margin: 8px 0; padding: 10px 14px; background: #fff"
            class="card active"
            id="v-pills-2nd-tab"
            aria-controls="q12"
            aria-expanded="false"
            class="mb-0 collapsed"
            data-toggle="collapse"
            href="#q83"
          >
            <h5>
              <span
                class="btn active"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne_One"
                aria-expanded="true"
                aria-controls="collapseOne_One"
                class="card-header headingsize"
                >Safe and Secure</span
              >
              <i class="fas fa-chevron-down float-right"></i>
            </h5>
            <div
              aria-labelledby="q12"
              class="collapse"
              id="q83"
              role="tabpanel"
              data-parent="#v-pills-tab-list"
            >
              <div class="card-body">
                At grammarin.com, we understand how challenging it can be to
                write an original article. Therefore, the safety and security of
                your data is our priority. Since our rewriter tool doesn’t use
                the assistance of any third-party services, it doesn’t share
                your data. In fact, our tool completely erases the traces of
                uploaded data from its servers upon being reloaded.
              </div>
            </div>
          </a>
          <hr style="margin-top: 0px; margin-bottom: 0px" />
          <a
            class="nav-link nav-pills"
            style="margin: 8px 0; padding: 10px 14px; background: #fff"
            class="card active"
            id="v-pills-2nd-tab"
            aria-controls="q12"
            aria-expanded="false"
            class="mb-0 collapsed"
            data-toggle="collapse"
            href="#q84"
          >
            <h5>
              <span
                class="btn active"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne_One"
                aria-expanded="true"
                aria-controls="collapseOne_One"
                class="card-header headingsize"
                >Extensive File Support</span
              >
              <i class="fas fa-chevron-down float-right"></i>
            </h5>
            <div
              aria-labelledby="q12"
              class="collapse"
              id="q84"
              role="tabpanel"
              data-parent="#v-pills-tab-list"
            >
              <div class="card-body">
                This AI rewriting tool is a universal web utility. From PDF and
                Word to raw text files, users can upload all types of documents
                to this tool. It will revamp their wording while keeping the
                original context intact.
              </div>
            </div>
          </a>
          <hr style="margin-top: 0px; margin-bottom: 0px" />
          <a
            class="nav-link nav-pills"
            style="margin: 8px 0; padding: 10px 14px; background: #fff"
            class="card active"
            id="v-pills-2nd-tab"
            aria-controls="q12"
            aria-expanded="false"
            class="mb-0 collapsed"
            data-toggle="collapse"
            href="#q85"
          >
            <h5>
              <span
                class="btn active"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne_One"
                aria-expanded="true"
                aria-controls="collapseOne_One"
                class="card-header headingsize"
                >Multilingual Accessibility and Operability</span
              >
              <i class="fas fa-chevron-down float-right"></i>
            </h5>
            <div
              aria-labelledby="q12"
              class="collapse"
              id="q85"
              role="tabpanel"
              data-parent="#v-pills-tab-list"
            >
              <div class="card-body">
                The article rewriter by grammarin.com has been developed to
                operate in multiple languages. With this web utility, you can
                generate high-quality, revamped versions of your articles
                written in any popular language.
              </div>
            </div>
          </a>
          <hr style="margin-top: 0px; margin-bottom: 0px" />
          <a
            class="nav-link nav-pills"
            style="margin: 8px 0; padding: 10px 14px; background: #fff"
            class="card active"
            id="v-pills-2nd-tab"
            aria-controls="q12"
            aria-expanded="false"
            class="mb-0 collapsed"
            data-toggle="collapse"
            href="#q86"
          >
            <h5>
              <span
                class="btn active"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne_One"
                aria-expanded="true"
                aria-controls="collapseOne_One"
                class="card-header headingsize"
                >No Word Count Limit</span
              >
              <i class="fas fa-chevron-down float-right"></i>
            </h5>
            <div
              aria-labelledby="q12"
              class="collapse"
              id="q86"
              role="tabpanel"
              data-parent="#v-pills-tab-list"
            >
              <div class="card-body">
                Our tool understands that sometimes, articles can be lengthy.
                Therefore, it has been programmed to handle lengthy chunks of
                text in one go. You won’t have to break a long article into
                multiple sections in order to rewrite it with our web utility.
              </div>
            </div>
          </a>
          <hr style="margin-top: 0px; margin-bottom: 0px" />
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid my-5" style="background: #ecf6f5">
  <div class="container">
    <div
      class="row justify-content-center"
      style="display: flex; align-items: center; padding: 30px 0px"
    >
      <div class="col-md-7 left-section">
        <h2 class="freeGrammarFont" id="align-center">
          Working Mechanism of Our Rewriter Tool
        </h2>
        <p class="freeGrammarFont-p mt-3" id="align-center">
          The article rewriter tool by GrammarIn works like linguistic geniuses.
          This web utility makes use of sophisticated artificial intelligence
          technologies like Natural Language Processing and machine learning
          models. Natural Language Processing (also known as NLP) helps our tool
          comprehend the input and its context. This technology meticulously
          dissects the input and deftly identifies its key elements. The machine
          learning (ML) models of this rewriter tool take care of the actual
          rewording procedure. They rewrite the identified key elements by using
          alternative wording, changing the order of words, and altering the
          structure of phrases. Since the ML models of this tool have been
          trained on the extensive writing patterns of humans, this web utility
          knows how to craft engaging alternatives while maintaining the essence
          of the original input.
        </p>
      </div>
      <div class="col-md-5 right-section">
        <img
          class="how-to-img"
          src="../../assets/images/article-rewriter/Working Mechanism of Our Rewriter Tool.svg "
          alt="text-ig"
        />
      </div>
    </div>
  </div>
</div>
<div
  class="container justify-content-center"
  id="how-to-use-bg "
  style="margin-top: 100px"
>
  <div class="row mt-5" style="box-sizing: border-box">
    <div class="col-md-12">
      <h2
        style="
          text-align: center;
          font-size: 30px;
          font-weight: 700;
          line-height: 34px;
          text-align: center;
        "
        class="mbl_screen"
      >
        Who Can Benefit Most from This AI Rewriter? – Ideal Users
      </h2>
    </div>
    <div
      class="col-md-12"
      style="
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        line-height: 30px;
      "
    >
      <p>
        One of the major characteristics that make our tool the best article
        rewriter of all time is its gigantic audience base. People who <br />
        write some sort of content can benefit their write-ups from the AI
        capabilities of this web utility. Here are some of the most <br />
        common users of our rewriting tool:
      </p>
    </div>
  </div>
</div>
<div class="container text-center justify-content-center">
  <div class="row">
    <div class="col-lg-6">
      <img
        src="../../assets/images/article-rewriter/Academic Individuals.svg"
        class="article-8-img"
        alt="summarize"
      />
    </div>
    <div class="col-lg-6">
      <h2 class="fnt-w600-30 article-8-h2 mt-5">Academic Individuals</h2>
      <p class="fnt-18-400 mt-4 article-8-p">
        Plagiarism is a major issue in the field of academia. Students and
        researchers often strive to combat this form of academic misconduct. But
        they do not succeed all the time. This is where our AI-based article
        rewriting web utility will come in handy.
      </p>
      <p class="fnt-18-400 mt-4 article-8-p">
        Our tool uses multiple modes, a combination of various rewriting
        strategies, and advanced technologies to produce a revamped version of
        the input. It has been programmed to always take a unique approach to
        rewriting the input. Therefore, it is guaranteed to eradicate duplicate
        portions within the submitted article.
      </p>
    </div>
  </div>
</div>
<div class="container text-center justify-content-center">
  <div class="row" id="artical-9">
    <div class="col-lg-6 left-section">
      <h2 class="fnt-w600-30 article-8-h2 mt-5">Journalists</h2>
      <p class="fnt-18-400 mt-4 article-8-p">
        Journalists often have to write articles in easy-to-understand wording
        and an unjumbled manner. But writing news articles in such a manner is
        not always possible. Sometimes, writer’s block halts people’s
        creativity. In such situations, people belonging to the field of
        journalism often face a hard time presenting their stories using
        easy-to-understand wording. This is where our AI rewriter tool will come
        in handy.
      </p>
      <p class="fnt-18-400 mt-4 article-8-p">
        Advanced rewriting techniques employed at the backend of our tool
        guarantee to produce highly readable outputs. Therefore, if writer’s
        block prevents you from writing articles using easy-to-understand
        wording, use this web utility to revamp your text and keep your audience
        engaged.
      </p>
    </div>
    <div class="col-lg-6 right-section">
      <img
        src="../../assets/images/article-rewriter/Journalists.svg"
        class="article-8-img"
        alt="summarize1"
      />
    </div>
  </div>
</div>
<div class="container text-center justify-content-center">
  <div class="row">
    <div class="col-lg-6">
      <img
        src="../../assets/images/article-rewriter/Corporate Professionals.svg"
        class="article-8-img"
        alt="summarize3"
      />
    </div>
    <div class="col-lg-6">
      <h2 class="fnt-w600-30 article-8-h2 mt-5">Corporate Professionals</h2>
      <p class="fnt-18-400 mt-4 article-8-p">
        Corporate professionals often have to highlight their professional goals
        in a concise and engaging manner. However, not all corporate
        professionals are fond of writing. If you are one of them, you can use
        the assistance of our article rewriter.
      </p>
      <p class="fnt-18-400 mt-4 article-8-p">
        This web utility is powerful enough to eliminate redundant wording or
        ideas and present the input in an engaging manner. Corporate
        professionals can use it to inject new life into the objective sections
        of their resumes. Doing so will ultimately prove helpful in catching the
        eye-balls of hiring managers and securing their dream job.
      </p>
    </div>
  </div>
</div>

<!-- frequently asked questions  section -->
<div class="mt-5 qustion" id="home-faqs">
  <div class="justify-content-center" id="row_faqs" style="margin-bottom: 80px">
    <div class="faqs text-center">
      <p
        class="text-center main-srn"
        style="font-size: 40px; font-weight: 600; line-height: 50.4px"
      >
        Frequently asked questions
      </p>
      <p class="text-center mb-srn">
        Frequently asked <br />
        questions
      </p>
      <p style="text-align: center" class="text mb-5 text">
        Learn more about platform by user questions
      </p>
    </div>
    <div class="v-pills-tab-list" id="v-pills-tab-list">
      <div id="row_faqs">
        <div
          class="container container-grid"
          style="width: min(100% - 40px, 768px)"
        >
          <div
            class="nav flex-column nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <a
              class="nav-link nav-pills"
              style="
                border: 1px solid #eaeaea;
                padding: 10px 14px;
                background-color: #f3f8fc;
                border-radius: 10px;
              "
              [ngClass]="{ active: activeTab === 'q5' }"
              (click)="toggleTab('q5')"
              id="v-pills-first-tab"
              aria-controls="q5"
              aria-expanded="false"
              class="mb-0 collapsed"
            >
              <div class="nav-linkFAQ">
                <h3
                  class="card-header ms-3"
                  [class.closed]="activeTab !== 'q5'"
                >
                  Is rewriting beneficial for SEO?
                </h3>
                <app-icons-free-tools
                  name="plusIcon"
                  *ngIf="activeTab !== 'q5'"
                />
                <app-icons-free-tools
                  name="minusIcon"
                  *ngIf="activeTab === 'q5'"
                />
              </div>

              <div
                aria-labelledby="q5"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q5' }"
                id="q5"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body carbody ms-3 me-3">
                  Yes. Rewriting can benefit the SEO of content in a plethora of
                  ways. For instance, this writing strategy can reduce
                  redundancy and bring variety to the vocabulary of the text.
                </div>
              </div>
            </a>
          </div>

          <div
            class="nav flex-column nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <a
              class="nav-link nav-pills"
              style="
                border: 1px solid #eaeaea;

                padding: 10px 14px;
                background-color: #f3f8fc;
                border-radius: 10px;
              "
              [ngClass]="{ active: activeTab === 'q15' }"
              (click)="toggleTab('q15')"
              id="v-pills-2nd-tab"
              aria-controls="q15"
              aria-expanded="false"
              class="mb-0 collapsed"
            >
              <div class="nav-linkFAQ">
                <h3
                  class="card-header ms-3"
                  [class.closed]="activeTab !== 'q15'"
                >
                  Is article rewriting legal?
                </h3>
                <app-icons-free-tools
                  name="plusIcon"
                  *ngIf="activeTab !== 'q15'"
                />
                <app-icons-free-tools
                  name="minusIcon"
                  *ngIf="activeTab === 'q15'"
                />
              </div>

              <div
                aria-labelledby="q15"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q15' }"
                id="q15"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body carbody ms-3 me-3">
                  Generally, rewriting is done to avoid plagiarism and improve
                  the overall quality of the text. Therefore, if you intend to
                  avoid plagiarism through this strategy, you must credit the
                  original information owner. Otherwise, your rewritten variant
                  will be considered plagiarized. tool.
                </div>
              </div>
            </a>
          </div>
          <div
            class="nav flex-column nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <a
              class="nav-link nav-pills"
              style="
                border: 1px solid #eaeaea;

                padding: 10px 14px;
                background-color: #f3f8fc;
                border-radius: 10px;
              "
              [ngClass]="{ active: activeTab === 'q6' }"
              (click)="toggleTab('q6')"
              id="v-pills-4th-tab"
              aria-controls="q6"
              aria-expanded="false"
              class="mb-0 collapsed"
            >
              <div class="nav-linkFAQ">
                <h3
                  class="card-header ms-3"
                  [class.closed]="activeTab !== 'q6'"
                >
                  How much do I have to pay in order to use this tool?
                </h3>
                <app-icons-free-tools
                  name="plusIcon"
                  *ngIf="activeTab !== 'q6'"
                />
                <app-icons-free-tools
                  name="minusIcon"
                  *ngIf="activeTab === 'q6'"
                />
              </div>

              <div
                aria-labelledby="q6"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q6' }"
                id="q6"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body carbody ms-3 me-3">
                  Nothing. All the features of our AI rewriting tool are 100%
                  free. There is no need to spend a dime or register yourself
                  with this web utility.
                </div>
              </div>
            </a>
          </div>

          <div
            class="nav flex-column nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <a
              class="nav-link nav-pills"
              style="
                border: 1px solid #eaeaea;

                padding: 10px 14px;
                background-color: #f3f8fc;
                border-radius: 10px;
              "
              [ngClass]="{ active: activeTab === 'q7' }"
              (click)="toggleTab('q7')"
              id="v-pills-5th-tab"
              aria-controls="q7"
              aria-expanded="false"
              class="mb-0 collapsed"
            >
              <div class="nav-linkFAQ">
                <h3
                  class="card-header ms-3"
                  [class.closed]="activeTab !== 'q7'"
                >
                  Why is it essential to use an article rewriter tool instead of
                  the manual approach?
                </h3>
                <app-icons-free-tools
                  name="plusIcon"
                  *ngIf="activeTab !== 'q7'"
                />
                <app-icons-free-tools
                  name="minusIcon"
                  *ngIf="activeTab === 'q7'"
                />
              </div>

              <div
                aria-labelledby="q7"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q7' }"
                id="q7"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body carbody ms-3 me-3">
                  Manual rewriting requires great attention and top-notch
                  reading and writing skills. The absence of these skill sets
                  restricts the people from producing a rewritten variation of
                  the input. To combat this gap, AI rewriter tools come into the
                  picture. Such utilities take the manual effort out of the
                  picture and bring everyone to the same level.
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  -->
  <app-feedback></app-feedback>
  <a
    (click)="scrollToTop()"
    *ngIf="shouldShowButton"
    id="scroll-to-top"
    data-tooltip="Go to top"
  >
    <app-icons-free-tools name="goToTopIcon" />
  </a>

  <app-premium-modal-startup />

  <app-footer></app-footer>
</div>
